<template>
  <div>
    <div>
      <div
        :class="[
          'main',
          'login-top',
          'hidden-sm-and-down',
          { 'main-all': articleRoute },
        ]"
      >
        <el-row :gutter="10" style="width: 100%">
          <el-col
            :xs="24"
            :sm="24"
            :md="8"
            :lg="8"
            :xl="8"
            style="text-align: left"
          >
            <img
              src="https://img.wch.cn/20250210/wch_logo.png"
              alt=""
              class="logo"
            />
          </el-col>
          <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
            <div class="top-right">
              <div v-if="user && Object.keys(user).length > 0">
                <div class="header-link" style="margin-bottom: 10px">
                  <el-dropdown trigger="click" @command="handleCommand">
                    <el-badge :is-dot="unread" class="item">
                      <el-avatar
                        class="el-dropdown-link"
                        shape="square"
                        size="40"
                        fit="fill"
                        :src="
                          user && user.avatar
                            ? url + user.avatar
                            : 'https://www.wch.cn/uploads/avatar/head.gif'
                        "
                      ></el-avatar>
                    </el-badge>

                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="my"> 我的 </el-dropdown-item>

                      <el-dropdown-item command="pm"> 站内信 </el-dropdown-item>

                      <el-dropdown-item command="exit"> 退出 </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>

                  <!-- <a href="https://www.wch.cn/" class="hidden-sm-and-down"
                    >主站</a
                  > -->
                </div>
              </div>

              <div v-else>
                <div class="header-link hidden-sm-and-down">
                  <router-link :to="{ path: '/join' }"> 注册</router-link>
                  <a href="https://www.wch.cn/">主站</a>
                </div>

                <el-row class="login-btn-row" :gutter="15">
                  <el-col
                    :xs="24"
                    :sm="24"
                    :md="8"
                    :lg="8"
                    :xl="8"
                    class="login-btn"
                  >
                    <a @click="handleQQLogin" href="javascript:void(0)">
                      <el-button type="primary" class="btn-qq">
                        <i class="iconfont icon-QQ"></i>
                        QQ
                      </el-button>
                    </a>
                    QQ登录
                  </el-col>
                  <el-col
                    :xs="24"
                    :sm="24"
                    :md="8"
                    :lg="8"
                    :xl="8"
                    class="login-btn"
                  >
                    <a @click="handleWechatLogin" href="javascript:void(0)">
                      <el-button type="primary" class="btn-wechat">
                        <i class="iconfont icon-weixin"></i>
                        微信
                      </el-button>
                    </a>

                    扫一扫, 微信登录
                  </el-col>
                  <el-col
                    :xs="24"
                    :sm="24"
                    :md="8"
                    :lg="8"
                    :xl="8"
                    class="login-btn"
                  >
                    <el-button
                      type="primary"
                      class="btn-wch"
                      @click="onUsernameBtnClick"
                    >
                      <i class="el-icon-user-solid"></i>
                      账号登录
                    </el-button>
                    账号密码登录
                  </el-col>
                  <el-col
                    :xs="24"
                    :sm="24"
                    :md="8"
                    :lg="8"
                    :xl="8"
                    class="login-btn hidden-sm-and-up"
                  >
                    <el-button class="btn-wch-join" @click="onJoinBtnClick">
                      <i class="el-icon-lock"></i>
                      社区注册
                    </el-button>
                    注册您的账号
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="navbar hidden-sm-and-down">
      <div :class="['main', { 'main-all': articleRoute }]">
        <div class="navbar-menu horizontal-menu">
          <ul>
            <li><router-link :to="{ path: '/' }">首页</router-link></li>
            <li v-for="item in menu" :key="item.id" class="hidden-xs-only">
              <router-link :to="{ path: '/forums/' + item.aliase + '.html' }">
                {{ item.name }}</router-link
              >
            </li>

            <li><router-link to="/terms.html">用户须知</router-link></li>
          </ul>

          <div class="right-menu">
            <el-input
              size="small"
              v-model="searchKeyWord"
              placeholder="搜索"
              autocomplete="off"
              clearable
              @keydown.enter.native="onEnterKeySearch2"
            >
              <i
                class="el-icon-search el-input__icon search-btn"
                slot="suffix"
                @click="onSearch"
              >
              </i
            ></el-input>
          </div>
        </div>
      </div>
    </div>

    <div class="navbar navbar-mobile hidden-sm-and-up">
      <div class="main">
        <el-menu class="el-menu-demo" mode="horizontal">
          <el-menu-item index="home" class="mobile-index">
            <router-link :to="{ path: '/' }">
              <img
                src="https://img.wch.cn/20250210/wch.svg"
                alt=""
                width="30px"
                style="border-radius: 5px"
            /></router-link>
          </el-menu-item>
          <div class="right-menu" v-if="user && Object.keys(user).length > 0">
            <i class="el-icon-search mobile-search" @click="showSearch"> </i>

            <a
              @click="handleMy()"
              href="javascript:void(0)"
              class="mobile-avatar"
            >
              <el-avatar
                shape="square"
                size="40"
                fit="fill"
                :src="
                  user && user.avatar
                    ? url + user.avatar
                    : 'https://www.wch.cn/uploads/avatar/head.gif'
                "
              ></el-avatar>
            </a>

            <!-- <a
                href="javascript:void(0)"
                style="margin-right: 5px"
                @click="onExist(user.id)"
                >退出</a
              > -->
          </div>
          <div class="right-menu" v-else>
            <i class="el-icon-search mobile-search" @click="showSearch"> </i>

            <router-link to="/login"
              ><el-button type="primary" size="medium">登录</el-button>
            </router-link>
          </div>
        </el-menu>
      </div>
    </div>

    <el-dialog title="搜索" :visible.sync="mobileFormVisible" width="90%">
      <el-input
        v-model="searchKeyWord"
        placeholder="搜索"
        autocomplete="off"
        @keydown.enter.native="onEnterKeySearch2"
      >
        <i
          class="el-icon-search el-input__icon search-btn"
          slot="suffix"
          @click="onSearch"
        >
        </i
      ></el-input>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { exist, snsToken } from "@/service/user";
import UserAvatar from "@/components/UserAvatar";
export default {
  components: {
    UserAvatar,
  },
  computed: {
    ...mapGetters(["menu", "user", "unread"]),
    articleRoute() {
      return this.$route.path.startsWith("/article");
    },
  },
  data() {
    return {
      searchKeyWord: "",
      mobileFormVisible: false,
      url: "",
    };
  },
  created() {
    this.getInfo();
    this.url = process.env.VUE_APP_IMG_API + "/avatar/";
  },
  watch: {
    "$route.query": {
      handler() {
        this.getQ();
      },
    },
    $route() {
      this.getInfo();
      //this.getUnRead();
    },
  },
  mounted() {
    this.getMenu();
    this.getQ();
    
  },
  methods: {
    handleCommand(command) {
      //this.$message("click on item " + command);

      if (command === "my") {
        this.handleMy();
      }

      if (command === "pm") {
        this.handlePm();
      }

      if (command === "exit") {
        this.onExist();
      }
    },
    showSearch() {
      this.mobileFormVisible = true;
    },
    getUnRead() {
      const hasToken = localStorage.getItem("WCH-TOKEN");
      if (hasToken) {
        this.$store.dispatch("user/read");
      }
    },
    getQ() {
      this.searchKeyWord = this.$route.query.q ? this.$route.query.q : null;
    },
    getInfo() {





      const hasToken = localStorage.getItem("WCH-TOKEN");
      const path = this.$route.path;
      const threadRegex = /thread-\d+-\d+\.html/;
      const forunmRegex = /forum-\d+-\d+\.html/;
      const userId = this.$route.params.id
        ? this.$route.params.id
        : 2;
      if (
        threadRegex.test(path) ||
        forunmRegex.test(path) ||
        path === "/search.html" ||
        path === "/u/" + userId ||
        path === "/link/"
      ) {
        const current = this.$route.params.current
          ? this.$route.params.current
          : 1;
        if (current > 5 || path === "/search.html" || (path === "/u/" + userId || path === "/link/")) {
          if (!hasToken) {
            this.$router.push({
              path: "/login",
              query: {
                redirect: this.$route.fullPath,
              },
            });

            this.$notify.info({
              title: "提醒",
              message: "登录账户，使用更多功能",
            });
          }
        }
      }
      if (hasToken) {
        this.$store.dispatch("user/getInfo")
        .then(res=>{
          if(res.code === 0){


            this.getUnRead();

          }
        })
        .catch((error) => {
          if (error.response.status === 401) {
            localStorage.removeItem("WCH-TOKEN");
            this.$router.push({
              path: "/login",
              query: {
                redirect: this.$route.fullPath,
              },
            });
          }
        });
      } else {
        this.$store.dispatch("user/exist");
      }
    },
    handleMy() {
      // alert("234234234");
      this.$router.push({
        path: "/my",
        query: {
          tab: "info",
          time: this.$dayjs().format("YYYYMMDDHHmmssSSS"),
        },
      });
    },
    handlePm() {
      this.$router.push({
        path: "/my",
        query: {
          tab: "pm",
          time: this.$dayjs().format("YYYYMMDDHHmmssSSS"),
        },
      });
    },
    getMenu() {
      this.$store.dispatch("app/getForumMenu");
    },

    onEnterKeySearch() {
      console.info("----en----");
      this.onSearch();
    },
    onEnterKeySearch2() {
      console.info("----e2----");
      this.onSearch();
    },
    onSearch() {
      if (this.searchKeyWord === null || this.searchKeyWord === "") {
        this.$message.warning("请输入搜索内容");
        return;
      }

      //searchKeyWord 长度大于3 才搜索
      if (this.searchKeyWord.length <= 1) {
        this.$message.warning("请输入至少2个字符");
        return;
      }

      this.mobileFormVisible = false;

      this.$router.push(
        "/search.html?q=" +
          this.searchKeyWord +
          "&current=1&type=dateline&range=主题&keywordType=0" +
          "&time=" +
          this.$dayjs().format("YYYYMMDDHHmmssSSS")
      );
    },
    onSearch2() {
      if (
        this.searchForm.searchKeyWord === null ||
        this.searchForm.searchKeyWord === ""
      ) {
        this.$message.warning("请输入搜索内容");
        return;
      }

      //searchKeyWord 长度大于3 才搜索
      if (this.searchForm.searchKeyWord.length <= 1) {
        this.$message.warning("请输入至少2个字符");
        return;
      }
      this.mobileFormVisible = false;

      this.$router.push(
        "/search.html?q=" +
          this.searchForm.searchKeyWord +
          "&time=" +
          this.$dayjs().format("YYYYMMDDHHmmssSSS")
      );
    },
    onUsernameBtnClick() {
      this.$router.push(
        "/login" + "?time=" + this.$dayjs().format("YYYYMMDDHHmmssSSS")
      );
    },
    onJoinBtnClick() {
      this.$router.push(
        "/join" + "?time=" + this.$dayjs().format("YYYYMMDDHHmmssSSS")
      );
    },

    //href="https://open.weixin.qq.com/connect/qrconnect?appid=wx36af4358add6e109&redirect_uri=http://www.wch.cn/wechat/login&response_type=code&scope=snsapi_login&state=test888888#wechat_redirect"
    handleWechatLogin() {
      snsToken({ type: "wechat" }).then((response) => {
        const { code, data, message } = response;
        if (code == 0) {
          const state = data;
          window.location.href =
            "https://open.weixin.qq.com/connect/qrconnect?appid=wx36af4358add6e109&redirect_uri=http://www.wch.cn/bbs/wechat/login&response_type=code&scope=snsapi_login&state=" +
            state +
            "#wechat_redirect";
        } else {
          this.$message.error(message);
        }
      });
    },
    //"https://graph.qq.com/oauth2.0/show?which=Login&display=pc&client_id=101860927&redirect_uri=http%3A%2F%2Fwww.wch.cn%2Fqq&scope=get_user_info&response_type=code&state=d94c7c2dd88a38fec72f362c4dffafb1c66f8c65"
    handleQQLogin() {
      snsToken({ type: "qq" }).then((response) => {
        const { code, data, message } = response;
        if (code == 0) {
          const state = data;
          window.location.href =
            "https://graph.qq.com/oauth2.0/show?which=Login&display=pc&client_id=101860927&redirect_uri=http%3A%2F%2Fwww.wch.cn%2Fqq&scope=get_user_info&response_type=code&state=" +
            state;
        } else {
          this.$message.error(message);
        }
      });
    },

    // async logout() {
    //   await this.$store.dispatch("user/logout");
    //   this.$router.push(`/login?redirect=${this.$route.fullPath}`);
    // },
    onExist() {
      exist({})
        .then((response) => {
          const { code, data, message } = response;
          if (code == 0) {
            this.html = null;
            // 删除token
            localStorage.removeItem("WCH-TOKEN");
            this.$store.dispatch("user/exist").catch((error) => {
              if (
                error.response.status === 401 &&
                this.$route.path != "/login"
              ) {
                this.$router.push(
                  "/login?time=" + this.$dayjs().format("YYYYMMDDHHmmssSSS")
                );
              }
            });

            this.$message({
              message: "您已经退出",
              type: "success",
            });
            this.$router.push(
              "/login?time=" + this.$dayjs().format("YYYYMMDDHHmmssSSS")
            );
          } else {
            this.$message.error(message);
          }
        })
        .catch((error) => {
          console.error(error);
        });

      // 先删除redis中的登录信息
    },
  },
};
</script>

<style lang="less" scoped>
.login-top {
  padding-top: 10px;
  display: flex;
  .logo {
    height: 300px;
    height: 90px;
  }

  .top-right {
    width: 100%;
    text-align: right;
    .login-btn-row {
      //min-width: 450px;
      float: right;
      .login-btn {
        // float: left;
        min-width: 150px;
        // margin-left: 10px;
        text-align: left;
        margin-bottom: 10px;
        .btn-qq {
          background-color: #0098e6;
          border: none;
          color: #fff;
          display: block;
          width: 100%;
        }
        .btn-wechat {
          background-color: #00b500;
          color: #fff;
          border: none;
          display: block;
          width: 100%;
        }
        .btn-wch {
          background-color: #2469f6;
          color: #fff;
          border: none;
          display: block;
          width: 100%;
        }
        .btn-wch-join {
          display: block;
          width: 100%;
        }
      }
    }

    .header-link {
      float: right;
      width: 180px;
      a {
        text-align: right;
        margin-right: 15px;
      }
    }
  }
}

.navbar {
  min-height: 40px;
  border: none;
  background-color: #333;
  border-radius: 0;

  position: relative;

  .navbar-menu {
    display: block;
    height: 45px;
    ul {
      list-style: none;
      margin: 0;
      padding: 0;
      li {
        float: left;
      }
    }

    a {
      color: #e1e1e1;
      height: 45px;
      line-height: 45px !important;

      text-decoration: none;
      font-size: 18px;
      font-weight: bold;
      line-height: 20px;
      // padding: 12px 30px 0 0;
      text-align: left;
      display: block;
      margin-right: 30px;
      // width: 100px;
    }
    a:hover {
      color: #fff;
    }
    .right-menu {
      float: right;
      line-height: 45px;
      display: flex;
      .search-btn {
        cursor: pointer;
      }
    }
  }

  .el-menu {
    background-color: #333;
    border-bottom: none;

    a {
      color: #e1e1e1;
      min-height: 40px;
      height: 100%;
      text-decoration: none;
      font-size: 16px;
      font-weight: bold;
      line-height: 20px;
      padding: 10px 30px 0 0;
      display: block;
    }

    .el-menu-item {
      text-align: left;
      padding: 0;
      height: 40px;
      line-height: 40px;
    }
    .is-active {
      background-color: #333 !important;
      color: #fff;
      border-bottom: none;
    }
    .el-menu-item:not(.is-disabled):hover {
      background-color: #333 !important;
      color: #fff;
    }
  }
  .right-menu {
    float: right;
    line-height: 45px;
    display: flex;
    .search-btn {
      cursor: pointer;
    }
  }
}
.navbar-mobile {
  border-top: 3px solid #00428d !important;
  min-height: 50px !important;
  .mobile-index {
    a {
      padding: 0 !important;
      line-height: 50px !important;
      img {
        width: 40px;
        height: 40px;
      }
    }
  }
  .mobile-search {
    width: 40px;
    line-height: 50px;
    color: #fff;
    cursor: pointer;
    font-size: 25px;
    margin-right: 10px;
  }
  .mobile-avatar {
    line-height: 40px;
    margin-top: 5px;
    cursor: pointer;
    padding: 0 !important;
    line-height: 50px !important;
    .el-avatar {
      line-height: 50px !important;
      display: block !important;
    }
  }
  a {
    padding: 0px !important;
    line-height: 50px !important;
  }
  .el-button {
    background-color: #00428d !important;
    padding: 10px 15px;
    border: none;
    color: #fff;
    font-size: 14px;
    margin-left: 0.5rem !important;
  }
}
</style>
